import { TextField as MUITextField } from '@mui/material';
import { classNames } from '@partful/shared/lib/classNames';
import { ComponentProps, forwardRef } from 'react';
import styles from './Input.module.scss';

export type InputProps = Omit<ComponentProps<'input'>, 'size' | 'color'> & {
  size?: 'small' | 'medium';
  error?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ size = 'medium', error, readOnly, className, children, ...rest }, ref) => (
    <MUITextField
      hiddenLabel
      variant="filled"
      size={size}
      inputRef={ref}
      error={error}
      inputProps={{ readOnly }}
      className={classNames(styles.base, styles[size], className)}
      {...rest}
    >
      {children}
    </MUITextField>
  )
);
